import { render, staticRenderFns } from "./EffectWrapper.vue?vue&type=template&id=3239c5eb&scoped=true&"
import script from "./EffectWrapper.vue?vue&type=script&lang=js&"
export * from "./EffectWrapper.vue?vue&type=script&lang=js&"
import style0 from "./EffectWrapper.vue?vue&type=style&index=0&id=3239c5eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3239c5eb",
  null
  
)

export default component.exports